import { UPDATE_UNREAD_COUNT } from '../actions';

export const unreadCount = (state = 0, action) => {
  switch (action.type) {
    case UPDATE_UNREAD_COUNT: {
      return action.unreadCount;
    }
    default:
      return state;
  }
};
